import React, { useCallback } from 'react';
import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import { Form } from './form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormProvider, useForm } from 'react-hook-form';
import { useCreateOffer } from 'core/offers/hooks';
import { CardHeader } from 'components/cards/header';

const CreatePage = () => {
    const navigate = useNavigate();

    // Mutation
    const mutation = useCreateOffer({
        onError: (err) => toast.error("Une Erreur est survenue"),
        onSuccess: (data: any) => {
            toast.success("L'offre a été créee");
            navigate(`/dashboard/offers/${data.id}`);
        }
    });

    // Form
    const methods = useForm({mode: 'onChange'});
    const { formState: { errors, dirtyFields }, reset } = methods;
    const onFormSubmit = (data: any) => mutation.mutate({data});
    const onReset = useCallback(() => reset({}), [reset]);

    return (
        <Box>
            <Box component='main'>
                <FormProvider {...methods}>
                    <Box component='form' onSubmit={methods.handleSubmit(onFormSubmit)} noValidate>
                        <CardHeader
                            title={`Nouvelle mission`}
                            rightComponent={(
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 3, gap: '1rem' }}>
                                    <Button variant='contained' color='secondary' onClick={onReset} disabled={mutation.isLoading || Object.keys(dirtyFields).length === 0}>
                                        Annuler
                                    </Button>
                                    <Tooltip title={Object.keys(errors).length > 0 ? 'Veuillez fixer les erreurs' : (Object.keys(dirtyFields).length === 0 ? 'Aucun champs a été modifié' : "")}>
                                        <span>
                                            <Button type='submit' variant='contained' color='primary' sx={{ color: 'white' }} disabled={mutation.isLoading || Object.keys(errors).length > 0 || Object.keys(dirtyFields).length === 0}>
                                                {mutation.isLoading && <CircularProgress size={10} />}
                                                Sauvegarder
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </Box>
                            )}
                        />
                        <Form />
                    </Box>
                </FormProvider>
            </Box>
        </Box>
    );
};

export { CreatePage };